"use strict";
/**
 * @module Services.GatewayControl
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gateway response following invocation of an operation.
 */
var InvokeOperationResponse = /** @class */ (function () {
    /**
     * Create a new InvokeOperationResponse instance
     * @param type response type
     * @param output the output of the operation, if there was any.
     */
    function InvokeOperationResponse(type, output) {
        this.type = type;
        this.output = output;
    }
    return InvokeOperationResponse;
}());
exports.InvokeOperationResponse = InvokeOperationResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/operations/invoke-operation-response.js
// module id = 1388
// module chunks = 0